import { useEffect, useRef } from 'react';
import { SelectPicker, Whisper, Tooltip } from 'rsuite';
import './basicDropdown.css';
import { Icon } from '@rsuite/icons';

const SvgIcon = <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7018 0.363457C14.0659 0.714929 14.0659 1.28478 13.7018 1.63625L7.48649 7.63625C7.1224 7.98772 6.5321 7.98772 6.16802 7.63625L0.297968 1.96958C-0.0661194 1.61811 -0.0661194 1.04826 0.297968 0.696791C0.662054 0.345319 1.25236 0.345319 1.61644 0.696791L6.82725 5.72706L12.3834 0.363457C12.7474 0.0119855 13.3378 0.0119855 13.7018 0.363457Z" fill="#17C653"/>
                </svg>


export default function BasicInput({
        label,
        placeholder,
        error,
        ...props
    }) {
    
    return (
        <div className='basicDropdownGroup'>
            <span className='basicDropdownAddon paragraph-10R'>
                {label}
            </span>
            <SelectPicker
                cleanable={false}
                searchable={false}
                block
                caretAs={() => SvgIcon}
                className={`${label ? "withLabel" : "noLabel"} paragraph-14R ${error ? "error" : ""}`} placeholder={placeholder}
                {...props}
            />
        </div>
    );
}